module.exports = __webpack_public_path__ + "img/dimensions-in-sound.a586bdb7.svg";